<template>
  <v-responsive>
    <template v-slot:activator="{ on }">
      <v-btn color="warning" small v-on="on">Top10</v-btn>
    </template>
    <v-card v-if="loaded">
      <v-card-title class="justify-center">
        Top Obras en Radio
      </v-card-title>
      <v-card-text>
        <Bar :chartdata="chartdata" :options="options" />
      </v-card-text>
    </v-card>
  </v-responsive>
</template>
<script>
import Bar from "@/components/regalias/Bar.vue";
import axios from "axios";
export default {
  props: ["liquidacionId"],
  data() {
    return {
      showDialog: false,
      loaded: false,
      chartdata: {
        labels: null,
        datasets: [
          {
            label: "Horas en aire",
            backgroundColor: "#f87979",
            data: []
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false
      }
    };
  },
  components: { Bar },
  mounted() {
    axios
      .get("/miapa/topobrasradio/" + this.liquidacionId)
      .then(res => {
        let labels = [];
        let data = [];
        res.data.forEach(element => {
          labels.push(element.obra);
          data.push(element.horas);
        });
        this.chartdata.labels = labels;
        this.chartdata.datasets[0].data = data;
        this.loaded = true;
      })
      .catch(err => console.log(err));
  }
};
</script>
